<template>
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path d="M16.5 7.5V11.25C16.5 15 15 16.5 11.25 16.5H6.75C3 16.5 1.5 15 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H10.5" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16.5 7.5H13.5C11.25 7.5 10.5 6.75 10.5 4.5V1.5L16.5 7.5Z" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.25 9.75H9.75" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.25 12.75H8.25" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>